// extracted by mini-css-extract-plugin
export default {"dialogContainer":"ProductCardDialog_dialogContainer__C6R2J","dialogBackdrop":"ProductCardDialog_dialogBackdrop__Dof6k","button":"ProductCardDialog_button__Drj-r"};